/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmTriggerV1TriggerEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_TRIGGER_V1_TRIGGER_EVENT_ENTITY_NAME = 'ixm.trigger.v1.TriggerEvent';
export const ixmTriggerV1TriggerEventEntity = new schema.Entity<IxmTriggerV1TriggerEvent>(IXM_TRIGGER_V1_TRIGGER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmTriggerV1TriggerEvent) => `${entity.metadata?.eventId}` });

